<script>
export default {
  props: {
    url: {
      type: String,
      required: false,
      default: null
    },
    isPrimary: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
<template>
  <a v-if="url" :class="[$style.button, isPrimary ? $style['button--primary'] : null]" :href="url" target="_blank" v-on="$listeners">
    <span :class="$style.slotWrapper">
      <BaseIcon v-if="icon" :name="icon" :size="18" :style="{ marginRight: '6px' }" />
      <slot />
    </span>
  </a>
  <span v-else :class="[$style.button, isPrimary ? $style['button--primary'] : null]" v-on="$listeners" >
    <span :class="$style.slotWrapper">
      <BaseIcon v-if="icon" :name="icon" :size="18" :style="{ marginRight: '6px' }" />
      <slot />
    </span>
  </span>
</template>
<style lang="scss" module>
@import '@design';
.button {
  display: block;
  max-width: 100%;
  padding: 6px 16px;
  overflow: hidden;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid transparent;
  border-color: $color-text;
  border-radius: 22px;

  @media screen and (min-width: $size-breakpoint-sm) {
    display: inline-block;
  }

  @media screen and (min-width: $size-breakpoint-lg) {
    padding: 11px 26px;
    border-radius: 30px;
  }

  @extend %typography-small;

  &,&:visited,&:hover {
    color: $color-text;
  }

  @media screen and (min-width: $size-breakpoint-md) {
    &:hover {
      box-shadow: 0 0 20px rgba(93,127,138,1);
    }
  }
}
.slotWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.button--primary {
  background-color: $color-text;
  &,&:visited,&:hover {
    color: $color-body-bg;
  }
}
.label--long {
  display: none;

  @media screen and (min-width: $size-breakpoint-md) {
    display: block;
  }
}
.label--short {
  display: block;

  @media screen and (min-width: $size-breakpoint-md) {
    display: none;
  }
}
</style>